import { defineMessages } from 'react-intl';

import { DivisionChange } from '@sorare/core/src/__generated__/globalTypes';

export const messages = defineMessages({
  [DivisionChange.PROMOTED]: {
    defaultMessage: 'Promoted',
  },
  [DivisionChange.RELEGATED]: {
    defaultMessage: 'Relegated',
  },
  [DivisionChange.STABLE]: {
    defaultMessage: 'Safe',
  },
  projectedToDiv: {
    defaultMessage: 'Proj. Div {division}',
  },
});
